/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-permit/shared-components/utils/async';
import {
    ADD_RESERVATION,
    UPDATE_RESERVATION,
    FETCH_RESERVATION,
    ADD_LOTTERY_APPLICATION,
} from '../constants/actions';
import * as api from '../api';

export const addReservation = makeAsyncAction(
    ADD_RESERVATION,
    (params) => () => api.addReservation(params),
    'payload'
);
export const updateReservation = makeAsyncAction(
    UPDATE_RESERVATION,
    (params) => () => api.updateReservation(params),
    'payload'
);
export const fetchReservation = makeAsyncAction(
    FETCH_RESERVATION,
    (permitId, issuanceId) => () => api.fetchReservation(permitId, issuanceId),
    'payload'
);
export const fetchUnpaidReservation = makeAsyncAction(
    FETCH_RESERVATION,
    (permitId, issuanceId) => () => api.fetchUnpaidReservation(permitId, issuanceId),
    'payload'
);
export const postLotteryIssuance = makeAsyncAction(
    ADD_LOTTERY_APPLICATION,
    (issuance) => () => api.postLotteryIssuance(issuance),
    'payload'
);
export const updateLotteryIssuance = makeAsyncAction(
    UPDATE_RESERVATION,
    (reservation) => () => api.updateLotteryIssuance(reservation),
    'payload'
);
export const fetchUnpaidLotteryIssuance = makeAsyncAction(
    FETCH_RESERVATION,
    (permitId, issuanceId, useNewMuxPath) => () =>
        api.fetchUnpaidLotteryIssuance(permitId, issuanceId, useNewMuxPath),
    'payload'
);
